import Master from "./Master";
import React,{useEffect,useState} from "react";
import { Link } from "react-router-dom";

function Service(){

  const [services, setServices] = useState([]);


  // LOAD
  const loadServices = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allservice.php");
    const data = await res.json();
    setServices(data);
  };

  useEffect(() => {
    loadServices();
  }, []);


    return(
        <Master>
    {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque"><span>Our</span> Services</h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">our services</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Services Start */}
    <div className="page-services">
        <div className="container">
            <div className="row">
                {services.map((s) => (
                <div className="col-lg-3 col-md-6" key={s.id}>
                    {/* Service Item Start */}
                    <div className="service-item wow fadeInUp">
                        <div className="icon-box">
                            <div className="img">
                                <img src="images/icon-services-1.svg" alt={s.name} />
                            </div>
                        </div>
                        <div className="service-body">
                            <h3>{s.name}</h3>
                            <p>{s.title}</p>
                        </div>
                        <div className="read-more-btn">
                            <Link to={`/servicedetails/${s.id}`}>read more</Link>
                        </div>
                    </div>
                    {/* Service Item End */}
                </div>
                ))}
            </div>
        </div>
    </div>
    {/* Page Services End */}
        </Master>
    );
}

export default Service;